module.exports = __webpack_public_path__ + "static/media/img_04.3cc927bd.png";